import React from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const muiCache = createCache({
	"key": "mui",
	"prepend": true
});
const columns = [
 {
  name: "c_name",
  label: "Course Name",
  options: {
   filter: false,
   sort: true,
  }
 },
 {
  name: "c_code",
  label: "Course Code",
  options: {
   filter: false,
   sort: true,
   display:false,
  }
 },
  {
  name: "cr_hr",
  label: "Cr.Hr",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "n_section",
  label: "Sections",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "n_students",
  label: "Students",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "lec",
  label: "Lecture ",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "lab",
  label: "Lab ",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "tut",
  label: "Tutorial",
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "tot",
  label: "Total",
  options: {
   filter: false,
   sort: true,
  }
 },
]

const data = [
 ["Internet Programming","SWEG303", "3", "3","50", "2","2","0","4"],
 ["Object-Oriented Programming","SWEG301","4", "4","30", "2","3","0","5"],
 ["Fundamental of Programming","SWEG203","3", "4","50","2","3", "0","5"],
 ["Fundamental of Programming","SWEG203", "3", "4","50","2","4", "0","6"],
 

];


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  height:'100%',
  marginBottom: '30px',
  // '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px'
  // },
  // '& .css-1v17xvx-MuiTableCell-root':{
  //   padding:'0px',
  //   marginLeft:'-15px',
  // },
  // '& .css-10ud224-MuiTableCell-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',

  // },
}))
export default function OverloadTable(props) {
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={props.title}
  data={data}
  columns={columns}
  options={props.options}
/></CacheProvider>
 )} 